module.exports = __webpack_public_path__ + "media/doctor.cbae40d4df.png";